import { css, keyframes } from 'styled-components'

export const btnBackground = keyframes`
    0% {
     opacity: 0;
     animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
    }
    33% {
     opacity: 0.5;
     animation-timing-function: cubic-bezier(0.2, 0.1, 0.3, 1);
    }
   66% {
     opacity: 0;
   }
`

const loadingloop = keyframes`
   0% {
     stroke-dashoffset: 534.7;
     stroke-dasharray: 0, 634.7;
   }
   10% {      
     stroke-dasharray: 124.7, 510;f
   }
   50% {
     stroke-dashoffset: -100;
     stroke-dasharray: 124.7, 510;
   }
   100% {
     stroke-dashoffset: -734.7;
     stroke-dasharray: 0, 634.7;
   }
`

export const loadingloopAnim = css`
  ${loadingloop}
`
export const fadeOutAnim = keyframes`
0% {
  transition-timing-function: cubic-bezier(0.5, 0, 0, 1);
  opacity:1; 
}
 100%{
    opacity:0; 
  } 
`

export const fadeOut = css`
  ${fadeOutAnim} 83ms forwards 1
`
